import cn from '@integrations/classnames'
import { formatDisplayDate, getNextRecurringExecutionDate, getRecurringFrequencyLabel } from '@utils'
import { tr } from 'mmfintech-commons'
import { LabelValue } from 'mmfintech-portal-commons'

import styles from './RecurringPreviewBlock.module.scss'

interface Props {
  isRecurringOpen?: boolean
  recurringPlanName?: string
  recurringStep?: string
  startDate?: string
}

function RecurringPreviewBlock({ isRecurringOpen, recurringPlanName, recurringStep, startDate }: Props) {
  if (!(isRecurringOpen && recurringPlanName && recurringStep && startDate)) {
    return null
  }

  const nextExecutionDate = getNextRecurringExecutionDate(startDate, recurringStep)

  return (
    <div
      className={cn(styles['recurring-preview-block'], 'recurring-preview-block')}
      data-test='recurring-preview-block'
    >
      <div className={cn(styles['recurring-preview-block-title'], 'recurring-preview-block-title')}>
        {tr('FRONTEND.BANKING.SEND_MONEY.PREVIEW.RECURRING_TRANSFER', 'Recurring transfer')}
      </div>

      <LabelValue
        label={tr('FRONTEND.BANKING.SEND_MONEY.PREVIEW.RECURRING_PAYMENT_NAME', 'Plan name')}
        value={recurringPlanName}
        dataTest='recurring-plan-name'
      />
      <LabelValue
        label={tr('FRONTEND.BANKING.SEND_MONEY.PREVIEW.FREQUENCY', 'Frequency')}
        value={getRecurringFrequencyLabel(recurringStep)}
        dataTest='recurring-frequency'
      />
      <LabelValue
        label={tr('FRONTEND.BANKING.SEND_MONEY.PREVIEW.START_DATE', 'Start date')}
        value={formatDisplayDate(startDate)}
        dataTest='recurring-start-date'
      />
      <LabelValue
        label={tr('FRONTEND.BANKING.SEND_MONEY.PREVIEW.NEXT_EXECUTION', 'Next execution')}
        value={formatDisplayDate(nextExecutionDate.toDate())}
        dataTest='recurring-next-execution'
      />
    </div>
  )
}

export default RecurringPreviewBlock
